// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Button, Text, Svg } from '@gandi/ui';

type Props = {
  /** action to remove the product */
  handleRemoveAction: (SyntheticEvent<HTMLButtonElement>) => mixed,

  /** action to set / unset confirmation step  */
  fireConfirmationStep: boolean => void,

  /** add warning just above the deletion confirmation */
  warningContent?: React.Node,
};

export default function ConfirmationStep({
  handleRemoveAction,
  fireConfirmationStep,
  warningContent,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const confirmButtons = (
    <Base flex flexWrap columnGap="xsmall">
      <Text>{__('Confirm removal?')}</Text>
      <Base flex flexWrap rowGap="xxsmall" columnGap="xsmall">
        <Button
          type="button"
          kind="link"
          intent="danger"
          onClick={(evt: SyntheticEvent<HTMLButtonElement>) => {
            handleRemoveAction(evt);
            fireConfirmationStep(false);
          }}
        >
          {__('Delete')}
        </Button>
        <Button
          type="button"
          kind="link"
          onClick={() => fireConfirmationStep(false)}
        >
          {__('Cancel')}
        </Button>
      </Base>
    </Base>
  );

  if (!warningContent) {
    return confirmButtons;
  }

  return (
    <Base flex gap="xsmall" flexAlignContentCenter>
      <Svg
        name="warningWire"
        theme="warning"
        size="4x"
        style={{ marginTop: 2 }}
      />
      <Base flex flexWrap columnGap="xsmall">
        {warningContent}

        {confirmButtons}
      </Base>
    </Base>
  );
}
